<template>
  <div class="tools-bar">
    <download-panel></download-panel>
    <!--<back-past></back-past>-->
    <full-screen v-model.trim="isFullScreen" v-if="false"></full-screen>
	<!-- 五育管理员/学校巡检管理员  隐藏帮助中心 -->
    <usage-guide v-show="userInfo.roleName !== '五育并举管理员'&& userInfo.roleName !== '学校巡检管理员'"></usage-guide>
     <lang-select></lang-select>
    <change-role v-if="false"></change-role>
    <profile-panel></profile-panel>
  </div>
</template>

<script>
import DownloadPanel from './download-panel';
import UsageGuide from './usage-guide';
// import LangSelect from './lang-select';
import FullScreen from './full-screen';
import ChangeRole from './change-role';
import ProfilePanel from './profile-panel';
import LangSelect from './lang-select';
// import BackPast from './back-past';

export default {
	name: 'tools-bar',
	data() {
		return {
			isFullScreen: false
		};
	},
	components: {
    LangSelect,
		DownloadPanel,
		UsageGuide,
		// LangSelect,
		ChangeRole,
		FullScreen,
		ProfilePanel
		// BackPast
	},
	computed: {
		userInfo() {
			return this.$store.state.user.userInfo;
		}
	}
};
</script>

<style lang="scss" scoped>
.tools-bar {
	display: flex;
	align-items: center;
	font-size: $-font-size-s;
	color: $-color-text-primary !important;
	.el-col {
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>
